import React, { Component } from 'react';
import { compose } from 'redux';
import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import Select, { components } from 'react-select';
import breakpoint from 'styled-components-breakpoint';
import EntityDropdownOption from 'components/molecules/EntityDropdownOption';

const SingleValueHeader = styled.div`
    font-size: ${props => (props.admin ? '1.5em' : '1.1em')};
    display: flex;
    justify-content: flex-start;
    width: 100%;
    ${breakpoint('xs', 'md')`
        justify-content: ${props => !props.admin && 'center'};
    `}
`;

const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>{children}</components.SingleValue>
);

const customStyles = props => ({
    option: provided => ({
        ...provided,
        borderBottom: `1px dotted ${props.theme.colors.lightgray}`,
        padding: '0 10px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: state.selectFocus ? 'hsl(0, 0%, 60%)' : 'hsl(0, 0%, 20%)'
    }),
    control: (provided, state) => ({
        ...provided,
        '&:hover': {
            boxShadow: state.menuIsOpen && `0 0 0 1px ${props.theme.global.colors.highlightColor}`,
            borderColor: state.menuIsOpen && `${props.theme.global.colors.highlightColor}`,
        },
        boxShadow: state.menuIsOpen && `0 0 0 1px ${props.theme.global.colors.highlightColor}`,
        borderColor: state.menuIsOpen && `${props.theme.global.colors.highlightColor}`,
        fontSize: '1em'
    })
});


class EntityDropdownContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectFocus: false
        };
    }

    render() {
        const { selectFocus } = this.state;
        const entityId = this.props.entityMeta.id;
        const entityName = this.props.entityMeta.name;
        const userEntities = this.props.userEntities;

        if (entityId && userEntities.length > 1) {
            const currentEntity = userEntities.find(e => e.value === entityId);

            const navChange = (value) => {
                const { currentPath, entityMeta } = this.props;
                // If we are on a /dashboard/ route, retain the Dashboard route and swap the Entity ID
                if (currentPath.includes('/dashboard/')) {
                    this.props.push(currentPath.replace(`/${entityMeta.id}/`, `/${value.id}/`));
                } else {
                    // NOTE: Currently, it shouldn't be possible
                    this.props.push(value.path);
                }
                this.entitySelectDropDown.blur();
            };

            return (
                <div style={{ display: 'block', width: '100%' }}>
                    { selectFocus && <div style={{ fontSize: '10px', paddingBottom: '2px' }}>Type to Search:</div> }
                    <Select
                        options={ userEntities }
                        value={ currentEntity }
                        onChange={value => navChange(value)}
                        onFocus={() => this.setState({ selectFocus: true })}
                        onBlur={() => this.setState({ selectFocus: false })}
                        styles={customStyles(this.props)}
                        components={{ Option: EntityDropdownOption, SingleValue }}
                        menuPlacement='auto'
                        placeholder={entityName}
                        ref={(ref) => { this.entitySelectDropDown = ref; }}
                    />
                </div>
            );
        }

        return (
            <SingleValueHeader admin={this.props.admin}>
                { this.props.admin ? this.props.title : entityName }
            </SingleValueHeader>
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: get(state, 'entities.meta', {}),
    userEntities: get(state, 'users.currentUser.userEntities', []),
    currentPath: get(state, 'router.location.pathname', '')
});

export default compose(
    withTheme,
    connect(mapStateToProps, { push })
)(EntityDropdownContainer);



// WEBPACK FOOTER //
// ./src/containers/EntityDropdownContainer.js